import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import UserComponent from 'components/hbUsers/UserComponent'
const styles = theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    width: 50,
    height: 50
  }
})
class NewPoolTransactionModal extends React.Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    selectUser: PropTypes.func.isRequired
  }
  state = {
    disabled: false
  }
  handleUserClick = user => {
    this.setState({ disabled: true })
    this.props.selectUser(user)
  }
  componentWillMount() {
    this.setState({ disabled: false })
  }
  render() {
    const { users } = this.props
    return (
      <ModalWrapper
        appBar
        open
        title={`Sélectionner un utilisateur`}
        showCancel={false}
        showOk={false}>
        <Grid container direction="row" alignItems="center" justify="center">
          {users.map(
            user =>
              user.show && (
                <UserComponent
                  key={user.key}
                  user={user}
                  disabled={this.state.disabled}
                  color={user.color}
                  onSelect={this.handleUserClick}
                />
              )
          )}
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(NewPoolTransactionModal)



// WEBPACK FOOTER //
// ./src/components/modals/client/SelectUserModal.js